import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBpoGnrGoPD7kMZpIOc2MsdjkW0mwNF1a8",
  authDomain: "disasterms-c42dc.firebaseapp.com",
  projectId: "disasterms-c42dc",
  storageBucket: "disasterms-c42dc.firebasestorage.app",
  messagingSenderId: "1025710542187",
  appId: "1:1025710542187:web:38543a7bc33c573f21d02e",
  measurementId: "G-EX5W01QYNF"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

// Diagnostic test to verify connection
import { signInAnonymously } from "firebase/auth";
signInAnonymously(auth)
  .then(() => console.log("✅ Firebase connection verified!"))
  .catch((err) => {
    console.error("❌ Firebase Connection Error:", err.code);
    console.error("Please ensure 'Identity Toolkit API' is enabled in Google Cloud Console.");
  });
